import React from 'react';
import {Dictionary} from '../../../../EOYWizard/types';

export type WidthState = {
    width: Dictionary<number>;
    setWidth: (id: string, width: number) => void;
    setFullWidth: (obj: Dictionary<number>) => void;
};

export const WidthContext = React.createContext<WidthState>({
    width: {},
    setFullWidth: () => {},
    setWidth: () => {}
});
